function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import "./styles.scss";

// Local Definitions

const baseClassName = styleNames.base;
const componentClassName = 'hamburger-button';
const hamburgerType = 'squeeze'; // docs : https://jonsuh.com/hamburgers/#sass

/**
 * This is the component description.
 */
const HamburgerButton = ({
  id,
  className: userClassName,
  style,
  children,
  isOpen,
  ariaLabel,
  color,
  ...otherProps
}) => /*#__PURE__*/React.createElement("button", _extends({
  id: id,
  className: [baseClassName, componentClassName, userClassName, `x-${color}`, 'hamburger', `hamburger--${hamburgerType}`, isOpen && 'is-active'].filter(e => e).join(' '),
  style: style,
  type: "button",
  "aria-label": ariaLabel,
  "aria-controls": "navigation"
}, otherProps), /*#__PURE__*/React.createElement("span", {
  className: "hamburger-box"
}, /*#__PURE__*/React.createElement("span", {
  className: "hamburger-inner"
})));
HamburgerButton.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   *  The children JSX
   */
  children: PropTypes.node,
  /**
   * Whether the menu is open
   */
  isOpen: PropTypes.bool.isRequired,
  /**
   * The button color
   */
  color: PropTypes.string,
  /**
   * The accessibility label
   */
  ariaLabel: PropTypes.string
};
HamburgerButton.defaultProps = {
  color: 'main1',
  ariaLabel: 'Menu'
};
export default HamburgerButton;